import React from 'react';

import {observer} from "mobx-react";
import styles from "../styles/entity-scores-widget.module.scss";
import classNames from "classnames";
import {Dropdown} from "../../../core/components/dropdown/dropdown";
import {EntityScoresWidgetDropdownItem} from "./entity-scores-widget.dropdown-item";
import {ENTITY_SCORES} from "../entity-scores-widget.consts";

export const EntityScoresWidgetDropdown = observer(({controller}) => {
  const {state: {dropdownFilterItems, shouldRenderDropdownFilters, isCompetitorPage, currentDropdownFilterItem}} = controller;
  const listClassName: String = !isCompetitorPage ? styles.dropdown_list : ""

  const dropdownProps = {
    items: dropdownFilterItems,
    selectedValue: currentDropdownFilterItem?.id,
    ListItem: EntityScoresWidgetDropdownItem,
    listItemProps: {controller},
    containerClassName: styles.dropdown_container,
    headerClassName: styles.dropdown_header,
    listClassName,
    onChange: (item) => controller.action(ENTITY_SCORES.ACTION_HANDLERS.onDropdownFilterChange, {id: item.id})
  }

  return (
    <div className={classNames(styles.dropdown)}>
      {
        shouldRenderDropdownFilters ? <Dropdown {...dropdownProps}/> : null
      }
    </div>
  )
});